import * as THREE from 'three';
import { EventDispatcher } from '../viewer-utils/event-dispatcher.js';

export class PointCloudTreeNode extends EventDispatcher {
  needsTransformUpdate: boolean;

  constructor() {
    super();
    this.needsTransformUpdate = true;
  }

  getChildren(): unknown[] {
    throw new Error('override function');
  }

  getBoundingBox(): THREE.Box3 {
    throw new Error('override function');
  }

  isLoaded(): boolean {
    throw new Error('override function');
  }

  isGeometryNode(): boolean {
    throw new Error('override function');
  }

  isTreeNode(): boolean {
    throw new Error('override function');
  }

  getLevel(): number | null {
    throw new Error('override function');
  }

  getNumPoints(): number {
    throw new Error('override function');
  }

  getBoundingSphere(): THREE.Sphere {
    throw new Error('override function');
  }
}

export class PointCloudTree<
  TEventMap extends THREE.Object3DEventMap = THREE.Object3DEventMap,
> extends THREE.Object3D<TEventMap> {
  root: PointCloudTreeNode | null;

  constructor() {
    super();
    this.root = null;
  }

  initialized(): boolean {
    return this.root !== null;
  }
}
